import React from 'react';
import { Route, Routes, useSearchParams } from 'react-router-dom';

import App from './App.tsx';
import Layout from './Layout.tsx';
import ErrorView from './components/error-view';
import NotFoundErrorView from './components/not-found-error-view';

const AppRoutes = () => {
    const [searchParams] = useSearchParams();
    /* istanbul ignore next -- @preserve */
    if (searchParams.has('api-env')) {
        // we set this global variable to dynamically manipulate the api environment from which the app is running
        window.USER_SET_API_ENV = searchParams.get('api-env');
    }

    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/:accessId" element={<App />} />

                <Route path="/:accessId/error" element={<ErrorView />} />

                <Route
                    path="/not-found"
                    element={
                        <NotFoundErrorView message="app.request.access.public.error.not.found" />
                    }
                />
                <Route
                    path="*"
                    element={
                        <NotFoundErrorView message="app.request.access.public.error.generic" />
                    }
                />
            </Route>
        </Routes>
    );
};

export { AppRoutes };
